import {
  type FieldHelperProps,
  type FieldInputProps,
  type FieldMetaProps,
  useField,
} from 'formik';
import {type FieldHookConfig} from 'formik/dist/Field';

const shouldShowErrorMessage = (meta: FieldMetaProps<string>): boolean => {
  if (!meta.touched) {
    return false;
  }

  return (
    Boolean(meta.value && !meta.touched && meta.error) ||
    Boolean(meta.touched && meta.error)
  );
};

export default function useInputFieldFormik(name: FieldHookConfig<string>): {
  field: FieldInputProps<string>;
  meta: FieldMetaProps<string>;
  helpers: FieldHelperProps<string>;
} {
  const [field, meta, helpers] = useField(name);

  if (!meta.error && shouldShowErrorMessage(meta)) {
    helpers.setError(' ');
  }

  return {field, meta, helpers};
}
